import React from 'react'
import { graphql } from 'gatsby'
import PostSections from '../components/PostSections'
import { getUser } from '../services/auth'

const PostVisibilityPrivate = ({ data }) => {
  let post = {}

  data.forEach(p => {
    if (p.node.password === getUser().username) {
      post = p.node
    }
  })
  // const post = data.contentfulPost
  return <PostSections post={post} />
}

export default PostVisibilityPrivate
